.button {
  border: none;
  background: rgb(27, 54, 209);
  border-radius: 10px;
  width: 100%;
  height: 40px;
  width: 100px;
  margin: 18px 0;
  line-height: 40px;
  font-size: 16px;
  font-family: 'Helvetica', sans-serif;
  padding: 0 10px;
  color: #fff;
  font-weight: bold;
  cursor: pointer;
}
.button:hover {
  background: rgb(18, 37, 145);
}